import React from 'react';
import { createRoot } from 'react-dom/client';
import { ExplorePanel } from './reusablePartials';
import { AppProvider } from './context/AppState.jsx';
import { ModalProvider } from './context/modalContext.jsx';
import useAppState from './hooks/useAppState.jsx';
import useInitializeAppData from './hooks/useInitializeAppData.js';
import i18n from './i18n';

// Function to mount React ExplorePanel on non-React pages
function mountExplorePanel() {
  // Check if we're on a React page (data.html, embed.html)
  const pathname = window.location.pathname;
  const isReactPage = pathname === '/data.html' || pathname === '/embed.html';

  // Only mount on non-React pages
  if (!isReactPage) {
    // Check if React ExplorePanel already exists
    if (document.getElementById('react-explorepanel-root')) {
      return;
    }

    // Find the viewpicker element
    const viewpickerElement = document.querySelector('.explore, .explore-home');
    if (!viewpickerElement) {
      console.warn('No viewpicker element found');
      return;
    }

    // Create a container for the React ExplorePanel
    const explorePanelContainer = document.createElement('div');
    explorePanelContainer.id = 'react-explorepanel-root';

    // Replace the viewpicker content with React ExplorePanel
    viewpickerElement.innerHTML = '';
    viewpickerElement.appendChild(explorePanelContainer);

    // Create the ExplorePanel app component with context
    const ExplorePanelApp = () => {
      const [state, dispatch] = useAppState();

      // Load essential data for ExplorePanel
      useInitializeAppData(state, dispatch, {
        includeExternalMetrics: true,
        includeIndexedYml: true,
        errorContext: 'ExplorePanel',
      });

      return (
        <AppProvider value={[state, dispatch]}>
          <ModalProvider>
            <ExplorePanel />
          </ModalProvider>
        </AppProvider>
      );
    };

    // Mount the React ExplorePanel using createRoot
    const root = createRoot(explorePanelContainer);
    root.render(<ExplorePanelApp />);
  }
}

// Mount ExplorePanel when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountExplorePanel);
} else {
  // Use setTimeout to ensure other scripts have loaded
  setTimeout(mountExplorePanel, 0);
}
